export const SET_LOADING = 'SET_LOADING';
export const SET_MESSAGE = 'SET_MESSAGE';


// WEBPACK FOOTER //
// ./src/store/mutations-type.js